import React from 'react';
import { useI18n } from '../../lib/i18n';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
export function Hero() {
  const {
    t
  } = useI18n();
  const scrollToForm = () => {
    document.getElementById('consultation')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden bg-luxury-espresso" data-id="element-71">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-fog-gradient" data-id="element-72" />
      <div className="absolute inset-0 bg-noise opacity-30 mix-blend-overlay pointer-events-none" data-id="element-73" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-74">
        {/* Text Content */}
        <div className="lg:col-span-7 flex flex-col items-start pt-10 lg:pt-0" data-id="element-75">
          <Reveal data-id="element-76">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-medium text-luxury-white leading-[1.1] mb-6 text-balance" data-id="element-77">
              {t('heroHeadline')}
            </h1>
          </Reveal>

          <Reveal delay={100} data-id="element-78">
            <p className="text-lg md:text-xl text-luxury-white/70 font-light leading-relaxed max-w-2xl mb-8" data-id="element-79">
              {t('heroSub')}
            </p>
          </Reveal>

          <Reveal delay={200} data-id="element-80">
            <div className="flex items-center gap-4 mb-10" data-id="element-81">
              <div className="h-px w-12 bg-luxury-gold/50" data-id="element-82" />
              <p className="text-sm font-medium text-luxury-gold tracking-wide uppercase" data-id="element-83">
                {t('heroTrust')}
              </p>
            </div>
          </Reveal>

          <Reveal delay={300} data-id="element-84">
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-12" data-id="element-85">
              <Button onClick={scrollToForm} className="w-full sm:w-auto" data-id="element-86">
                {t('btnPrimary')}
              </Button>
              <Button variant="outline" onClick={scrollToHowItWorks} className="w-full sm:w-auto" data-id="element-87">
                {t('btnSecondary')}
              </Button>
            </div>
          </Reveal>

          <Reveal delay={400} data-id="element-88">
            <div className="flex flex-wrap gap-3" data-id="element-89">
              {[t('chip1'), t('chip2'), t('chip3'), t('chip4')].map((chip, idx) => <span key={idx} className="px-4 py-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-sm text-xs text-white/60 font-medium tracking-wide" data-id="element-90">
                    {chip}
                  </span>)}
            </div>
          </Reveal>
        </div>

        {/* Image / Portrait */}
        <div className="lg:col-span-5 relative mt-12 lg:mt-0" data-id="element-91">
          <Reveal delay={300} data-id="element-92">
            <div className="relative aspect-[3/4] max-w-md mx-auto lg:ml-auto rounded-3xl overflow-hidden glass-panel-dark group" data-id="element-93">
              {/* Placeholder for Emelyn's Portrait */}
              <div className="absolute inset-0 bg-gradient-to-tr from-luxury-espresso to-luxury-charcoal" data-id="element-94" />
              <img src="https://images.unsplash.com/photo-1600607686527-6fb886090705?q=80&w=1000&auto=format&fit=crop" alt="" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-30 grayscale mix-blend-luminosity transition-transform duration-1000 group-hover:scale-105" data-id="element-95" />

              {/* Fog overlay on image */}
              <div className="absolute inset-0 bg-gradient-to-t from-luxury-espresso via-luxury-espresso/40 to-transparent" data-id="element-96" />

              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-97">
                <p className="text-xs text-white/70 tracking-widest uppercase border-l-2 border-luxury-gold pl-4" data-id="element-98">
                  {t('heroCaption')}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}